var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.productAdded)?_c('p',{on:{"click":_vm.addProduct}},[_vm._v(_vm._s(_vm.addLabel))]):_vm._e(),_vm._v(" "),(_vm.productAdded)?_c('a',{attrs:{"href":_vm.listLink}},[_vm._v(_vm._s(_vm.addedLabel))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }